module.exports = __webpack_public_path__ + "img/cartaz.8d880c0b.jpg";